export enum CollapseAnimationState {
    Collapsed = 'collapsed',
    Expanded = 'expanded',
}
